import type { ReatomEvmContainer } from "@rarible_int/anaconda_sdk/ethereum"
import { createScope } from "bunshi"

// Re-export Reatom versions
export {
  defaultBlockchainBalanceAtom,
  BlockchainBalanceSDKScope,
  BlockchainPublicClientScope,
  BlockchainScope,
  OrderIdScope,
  CollectionScope,
  MinimalDropScope,
  SDKNFTScope,
  NftMoleculeReatom as NftMolecule,
  ViewBlockchainMoleculeReatom as ViewBlockchainMolecule,
  BlockchainClientMoleculeReatom as BlockchainClientMolecule,
} from "./anaconda-sdk-scope.reatom"

// Default SDK values for scopes (null until SDK is initialized)
// Note: Eclipse SDK excluded from build - kept as placeholder for legacy compatibility
export const defaultEclipseSdk = null
export const defaultEvmSdk = null as unknown as ReatomEvmContainer

// Legacy exports for compatibility with code that expects "Atom" suffix
export const defaultEclipseSdkAtom = defaultEclipseSdk
export const defaultEvmSdkAtom = defaultEvmSdk

// Wallet-dependent SDK scopes (for transactions requiring signatures)
export const AnacondaEVMSDKScope = createScope<ReatomEvmContainer | null>(
  defaultEvmSdk,
)
